import { useController } from "react-hook-form"
import React, { useState } from "react"
import { IconButton, TextField } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons"

export const Field = ({ name, helperText, onChange, type, InputProps = {}, ...props }) => {
  const { field: { onChange: ctrlOnChange, ...field }, fieldState } = useController({ name })
  const [showPassword, setShowPassword] = useState(false)

  const handleInputChange = (event, ...args) => {
    if (typeof onChange === 'function')
      onChange(event, ...args)
    const value = event.target.value
    ctrlOnChange(value)
  }

  return <TextField id={`${name}Input`} {...props}
    {...field} onChange={handleInputChange}
    helperText={fieldState?.error?.message || helperText}
    error={!!fieldState?.error}
    type={type === 'password'
      ? (showPassword ? 'text' : 'password')
      : type
    }
    InputProps={{
      ...InputProps,
      [type === 'password' && 'endAdornment']: <IconButton onClick={() => setShowPassword(!showPassword)}>
        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} size='xs' />
      </IconButton>,
    }}
    InputLabelProps={{
      htmlFor: `${name}Input`,
      className: field.value ? 'Era-dirty' : ''
    }}
  />
}